import { IMAGES } from "../../lib/brand";

export const WhatIsMusemi = () => {
  return (
    <section
      id="about"
      data-testid="what-is-musemi-section"
      className="relative w-full bg-[#F6F2EC] pt-12 md:pt-16 pb-28 md:pb-40"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image — smaller, more refined */}
          <div className="lg:col-span-5">
            <div className="aspect-[1/1] w-full overflow-hidden bg-[#ECE6DE]">
              <img
                src={IMAGES.whatIs}
                alt="Woman in a white feathered gown lounging on a cream sofa — quiet luxury editorial"
                className="w-full h-full object-cover"
                data-testid="what-is-image"
              />
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-6 lg:col-start-7">
            <h2
              data-testid="what-is-heading"
              className="font-editorial text-[#2B2320] text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            >
              We're <span className="font-editorial-italic">redefining</span> how women access, experience, and share luxury fashion.
            </h2>

            <div className="mt-10 max-w-md space-y-5 text-[#2B2320] text-base md:text-lg leading-relaxed font-light">
              <p>
                Musemi blends rentals, listings, community, and curated experiences into a seamless fashion ecosystem.
              </p>
              <p className="font-editorial-italic text-[#634F50] text-xl md:text-2xl leading-snug pt-2">
                A place where women can rent, list, earn, and belong.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
